<script lang="ts">
    import { cn } from '$lib/utils/cn';

    import Fullscreen from 'svelte-fullscreen';
    import Player from 'svelte-react-player';

    import Close from './Close.svelte';
    import FullscreenCta from './FullscreenCta.svelte';
    import Preview from './Preview.svelte';

    import type { Language } from '$lib/types/Language';

    export let loading = true;
    export let url = '';
    export let ctaVisible = false;
    export let onBtnClick: () => void = () => null;
    export let btnText = 'Click me!';
    export let btnBgColor = '#0076FF';
    export let btnColor = '#F0F0F0';
    export let thumbnail = '';
    export let onProgress: (progress: { playedSeconds: number }) => void = () => null;
    export let language: Language = 'en';
    export let buttonBorderRadiusClass: string = '';
    export let containerBorderRadiusClass: string = '';

    let playing = false;
    let full = false;
    let ratio = '56.25%';

    const handleFullscreenChange = () => {
        full = !full;

        if (full) {
            setTimeout(() => {
                ratio = `${screen.height}px`;
                playing = true;
            }, 1000); // time it takes to enter fullscreen
        } else {
            playing = false;
        }
    };
</script>

<Fullscreen on:change={handleFullscreenChange} let:onRequest let:onExit>
    <div>
        <div class={cn('fun-block fun-size-full', { 'fun-hidden': playing })}>
            <Preview
                onPlayClick={() => onRequest()}
                src={thumbnail}
                {loading}
                {language}
                {containerBorderRadiusClass}
            />
        </div>
        <div
            class={cn(
                'fun-fixed fun-left-0 fun-top-0 fun-z-10 fun-block fun-h-full fun-w-full fun-bg-black',
                { 'fun-hidden': !playing },
            )}
        >
            <div class="fun-absolute fun-left-0 fun-top-0 fun-z-[1] fun-h-full fun-w-full">
                <Player {url} {playing} controls={false} fluid {ratio} callbacks={{ onProgress }} />
            </div>
            <Close onClose={() => onExit()} />
            <FullscreenCta
                {btnText}
                {btnColor}
                {btnBgColor}
                {onBtnClick}
                visible={ctaVisible}
                {buttonBorderRadiusClass}
            />
        </div>
    </div>
</Fullscreen>
